import useStore from "../store";
import {computed} from "vue";
import {storeToRefs} from "pinia";

export default function useReadyToPay() {
    const store = useStore();
    const { quote } = storeToRefs(store);

    // Create computed that depends on reactive quote state
    const readyToPay = computed(() => {
        if (quote.value.vouchers && quote.value.vouchers.length > 0){
            if (quote.value.totalDue === 0 && quote.value.totalAmount === quote.value.totalPaid){
                return true;
            }
        }

        return quote.value?.totalDue > 0;
    });

    return {
        readyToPay,
    };
}
